import { render, staticRenderFns } from "./FormTags.vue?vue&type=template&id=253a3c8d&scoped=true"
import script from "./FormTags.vue?vue&type=script&lang=js"
export * from "./FormTags.vue?vue&type=script&lang=js"
import style0 from "./FormTags.vue?vue&type=style&index=0&id=253a3c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a3c8d",
  null
  
)

export default component.exports